import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from './style/gstheme';

const styles = theme => {
    return Object.assign({
        inAppBar: {
            listStyleType: 'none',
            height: '40px',
            margin: '0px',
            padding: 0
        },
        inAppBarDeep: {
            listStyleType: 'none',
            height: '50px',
            margin: '0px',
            padding: 0
        },
        icon: {
            verticalAlign: 'text-bottom',
            marginRight: '5px'
        },
        itemClass: {
            float: 'left',
            display: 'block',
            width: '100px',
            color: theme.palette.text.disabled,
            fontSize: '14px',
            fontWeight: 500,
            textAlign: 'center',
            height: '20px',
            padding: '12px 10px 8px 10px',
            backgroundColor: 'transparent',
            '&:hover': {
                cursor: 'pointer'
            },
            '&:focus-visible': {
                outline: 'dashed 2px black'
            }
        },
        selected: {
            float: 'left',
            display: 'block',
            fontSize: '14px',
            fontWeight: 500,
            height: '20px',
            padding: '12px 10px 8px 10px',
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px',
            textAlign: 'center',
            color: theme.palette.primary.main,
            width: '100px',
            backgroundColor: 'white',
            '&:hover': {
                cursor: 'pointer'
            },
            '&:focus-visible': {
                outline: 'dashed 2px black'
            }
        }
    }, globalStyles);
};

class InAppBar extends React.Component {

    render() {

        const { tabValue, onChangeTab, tabItems, classes, size, deep, split, background } = this.props;
        const selectedTestName = tabItems[tabValue].name || tabItems[tabValue].label;

        return (
            <ul
                className={deep ? classes.inAppBarDeep : classes.inAppBar}
                style={background ? { backgroundColor: '#f5f5f5' } : {}}
                data-test={"menu-selected-" + selectedTestName}>
                {tabItems.map((item, index) => {
                    const selected = index === tabValue;
                    const itemClass = selected ? classes.selected : classes.itemClass;
                    const Icon = item.icon || null;
                    if (item.disabled) return null;
                    const testName = item.name || item.label;
                    return <li
                        key={index}
                        tabIndex={0}
                        data-selected={selected}
                        data-test={"menu-option-" + testName}
                        onKeyDown={(ev) => {
                            if (ev.key === "Enter") {
                                ev.preventDefault();
                                ev.stopPropagation();
                                onChangeTab && !item.grey && onChangeTab(index);
                            }
                        }}
                        style={size === "small" ?
                            {
                                width: 'auto',
                                ...(split <= index) && { float: 'right' },
                                ...(deep) && { height: 30 }
                            }
                            :
                            {
                                ...(split <= index) && { float: 'right' },
                                ...(deep) && { height: 30 }
                            }}
                        className={itemClass}
                        onClick={() => onChangeTab && !item.grey && onChangeTab(index)}>
                        {Icon && <Icon className={classes.icon} style={{ ...(item.grey) && { color: '#c0c0c0' } }} fontSize="small" />}
                        <span data-test={item.grey ? "menu-item-label-grey" : "menu-item-label"} style={{ ...(item.grey) && { color: '#c0c0c0' } }}>
                            {item.label}
                        </span>
                    </li>;
                })}
            </ul>
        );
    }
}

InAppBar.defaultProps = {
    tabValue: 0,
    split: 999,
    size: "small",
    deep: false,
    onChangeTab: null,
    background: true
};

InAppBar.propTypes = {
    tabValue: PropTypes.number,
    background: PropTypes.bool,
    deep: PropTypes.bool,
    size: PropTypes.oneOf(["small", "medium"]),
    tabItems: PropTypes.array.isRequired,
    split: PropTypes.number,
    onChangeTab: PropTypes.func,
    classes: PropTypes.object
};

export default withStyles(styles)(InAppBar);